import { render, staticRenderFns } from "./register-verify.vue?vue&type=template&id=1bcea542&scoped=true&"
import script from "./register-verify.vue?vue&type=script&lang=js&"
export * from "./register-verify.vue?vue&type=script&lang=js&"
import style0 from "./register-verify.vue?vue&type=style&index=0&id=1bcea542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcea542",
  null
  
)

export default component.exports